var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.03696 19.6203L9.16652 12.5039L2.03696 5.37493C1.31642 4.65445 1.29114 3.33989 2.06224 2.56884C2.82071 1.7978 4.14802 1.83572 4.85592 2.54356L11.9855 9.67255L19.115 2.5562C19.8609 1.81044 21.1376 1.81044 21.9087 2.58148C22.6798 3.33989 22.6798 4.62917 21.934 5.37493L14.8171 12.5039L21.934 19.6203C22.6798 20.366 22.6798 21.6553 21.9087 22.4137C21.1502 23.1848 19.8609 23.1974 19.115 22.439L11.9855 15.3227L4.85592 22.4516C4.14802 23.1721 2.83335 23.1974 2.06224 22.4264C1.29114 21.668 1.31642 20.3408 2.03696 19.6203Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.829aabcb39b43ba4fce977b209373ac7.svg";
export { ForwardRef as ReactComponent };